/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { useMemo } from 'react';
import { useWidgetParameter } from 'components/selectors/useWidgetParameter';
import { CommonDropdownWithLabel } from 'components/dropdowns/common-dropdown-with-label';

const valueFunction = (value) => value.value;

/**
 * Allows for the selection of a parameter with the given property name chosen from the given set of values
 *
 * @param cardIndex
 * @param propertyName
 * @param label
 * @param values
 * @param defaultValue
 * @param widgetConfiguration
 * @returns {JSX.Element}
 * @constructor
 */
export const WidgetParameterSelector = ({
	cardIndex,
	propertyName,
	label,
	values,
	defaultValue,
	widgetConfiguration,
	...rest
}) => {
	const handleSelectionChange = useWidgetParameter({ propertyName, cardIndex, widgetConfiguration, valueFunction });

	const activeItem = useMemo(() => {
		const activeName = widgetConfiguration?.[propertyName];
		return !(activeName===null||activeName===undefined) ? values.find((item) => item.value === activeName) : defaultValue;
	}, [defaultValue, propertyName, values, widgetConfiguration]);

	const optionToString = item => item.label;

	return (
		<CommonDropdownWithLabel
			options={values}
			onSelectionChanged={handleSelectionChange}
			activeItem={activeItem}
			optionToString={optionToString}
			label={label}

			btnText={optionToString(activeItem)}
			{...rest}
		/>
	);
};
